import React, { useState, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function App({ dataSource }) {
  var themeColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-theme")
    .trim();
  var inverse = getComputedStyle(document.body)
    .getPropertyValue("--bs-inverse")
    .trim();
  var bodyBg = getComputedStyle(document.body)
    .getPropertyValue("--bs-body-bg")
    .trim();

  const options = {
    indexAxis: "y",
    responsive: true,
    scales: {
      x: {
        ticks: {
          color: "#d7d7d7",
        },
        grid: {
          color: "#4b4b4b",
        },
      },
      y: {
        ticks: {
          color: "#d5d5d5",
        },
        grid: {
          color: "#4b4b4b",
        },
      },
    },
    plugins: {
      tooltip: {
        bodyColor: "#1e2936",
        backgroundColor: "#1e2936",
        callbacks: {
          labelTextColor: function (context) {
            return "#f8f8f8";
          },
        },
      },
      legend: {
        position: "bottom",
      },
    },
  };
  const [data, setData] = useState(null);
  const colors = [themeColor, "#f0ad4e", "#5cb85c", "#d9534f", "#5bc0de"];

  // labels will be the date of data source if it exist only one date in the label
  useEffect(() => {
    if (dataSource) {
      const labels = [];

      const datasets = [];
      dataSource.map((item, index) => {
        item.data.map((data) => {
          // if not exist in the labels array
          if (!labels.includes(data.day)) labels.push(data.day);
        });

        const datas = [];
        item.data.map((data) => {
          // if data.day not exist in the labels array set the value to 0
          if (!labels.includes(data.day)) {
            datas.push(0);
          } else {
            datas.push(data.count);
          }
        });
        datasets.push({
          label: item.location_name,
          data: datas,
          backgroundColor: colors[index],
          borderColor: colors[index],
        });
      });

      const data = {
        labels,
        datasets: datasets,
      };
      setData(data);
    }
  }, [dataSource]);

  return data ? (
    <div style={{ position: "relative", height: "270px", width: "100%" }}>
      <Bar options={options} data={data} />
    </div>
  ) : (
    <div>
      <div className="spinner-grow text-primary"></div>
    </div>
  );
}
export default App;
